import React from "react";
import ProgressBar from "components/raffle/ProgressBar";

interface IArcadeProgressBarProps {
  totalSteps: number;
  currentStep: number;
  showCurrentStep?: boolean;
  showRangeLabels?: boolean;
}

const ArcadeProgressBar = ({
  totalSteps,
  currentStep,
  showCurrentStep,
  showRangeLabels,
}: IArcadeProgressBarProps) => {
  return (
    <div className="arcadeProgressBar fullWidth flexCentered">
      <ProgressBar
        totalSteps={totalSteps}
        currentStep={currentStep}
        showRangeLabels={showRangeLabels}
        showCurrentStep={showCurrentStep}
      />

      <style jsx>
        {`
          :global(.arcadeProgressBar .rangeLabels p) {
            color: #50e3c2;
          }

          :global(.arcadeProgressBar .progressBar .filledBar) {
            color: #50e3c2;
            border-radius: 0;
            background-color: #50e3c2;
            box-shadow: none;
            height: 7px;
            top: -1px;
          }
        `}
      </style>
    </div>
  );
};

export default ArcadeProgressBar;
